/**
 * HubSpot Integration Module (Story 25.1)
 *
 * Barrel exports + adapter registration.
 */

import { registerAdapter } from "../registry";
import { hubspotAdapter } from "./hubspot";

// Register adapter at module load
registerAdapter("hubspot", hubspotAdapter);

// Platform constants
export const HUBSPOT_PLATFORM_VALUES = ["hubspot"] as const;
export type HubSpotPlatform = (typeof HUBSPOT_PLATFORM_VALUES)[number];

// Adapter + metrics/dimensions
export { hubspotAdapter, HUBSPOT_METRICS, HUBSPOT_DIMENSIONS } from "./hubspot";

// OAuth utilities
export {
  buildHubSpotAuthUrl,
  exchangeHubSpotCode,
  refreshHubSpotToken,
  verifyHubSpotAccessToken,
  parseHubSpotCallbackError,
  HUBSPOT_SCOPES,
  HUBSPOT_OPTIONAL_SCOPES,
  type HubSpotTokenResponse,
  type HubSpotTokenInfo,
  type HubSpotCallbackError,
} from "./oauth";

// API helpers
export {
  buildHubSpotHeaders,
  fetchPipelines,
  fetchOwners,
  fetchCrmObjects,
  searchCrmObjects,
  fetchContactProperties,
  fetchDealProperties,
  // Story 25.7: Traffic Analytics
  fetchTrafficTotals,
  fetchTrafficSources,
  fetchTrafficSessionsDaily,
  formatAnalyticsV2Date,
  // Story 25.9: Companies/Tickets/Engagements (scope-aware)
  fetchCrmObjectsWithScope,
  searchCrmObjectsWithScope,
  // Story 25.10: Forms + Marketing Events
  fetchForms,
  fetchFormSubmissionsCount,
  fetchMarketingEvents,
  // Story 25.11: Workflows + Custom Events
  fetchWorkflows,
  fetchWorkflowDetails,
  fetchEventDefinitions,
  fetchCustomEventCount,
  type HubSpotPipeline,
  type HubSpotPipelineStage,
  type HubSpotOwner,
  type HubSpotCrmObject,
  type TrafficTotalsResponse,
  type TrafficSourcesResponse,
  type TrafficSessionsDailyResponse,
  type HubSpotForm,
  type HubSpotMarketingEvent,
  type HubSpotWorkflow,
  type HubSpotWorkflowStats,
  type CustomEventDefinition,
} from "./api";

// Discovery helpers
export {
  fetchHubSpotPipelines,
  fetchHubSpotContactProperties,
  fetchHubSpotDealProperties,
  type PipelineDiscoveryResult,
} from "./discovery";

// Error parsing
export { parseHubSpotApiError, type HubSpotApiError } from "./errors";
